import { useSearchParams } from 'react-router-dom'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import { useOnboardingContext } from '../../providers/OnboardingProvider'
import { WorkflowPage } from '../workflows/WorkflowPage'

export const SetupDashboardVerifyCompletePage = () => {
    const navigate = usePSNavigate()
    const { advanceOnboardingState } = useOnboardingContext()
    const [searchParams, setSearchParams] = useSearchParams()
    const banner = searchParams.get('banner')

    const onNextHandler = async () => {
        if (banner) {
            return navigate('/')
        }
        await advanceOnboardingState()
    }

    return (
        <WorkflowPage
            onClose={() => navigate('/')}
            onBack={() => navigate('/golive/photo-verification')}
            backButtonTitle="Photo verification"
        >
            <div className="flex h-full flex-col items-stretch justify-center">
                <WorkflowPage.SuccessView
                    title="Conditionally verified!"
                    subtitle="Your profile has been conditionally verified and you’re ready to start collecting payments! You’ll receive a final notice within 2 business days and will be able to cash out payments once you’re fully verified. "
                    showLinksAsSingleColumn
                    links={[
                        {
                            id: 'deposit-funds',
                            title: 'Deposit funds',
                            subtitle: 'Add accounts to deposit your funds',
                            icon: 'cards.large',
                            onClick: onNextHandler,
                        },
                    ]}
                />
            </div>
        </WorkflowPage>
    )
}
